import * as React from "react";
const SvgInstagram = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    className="Instagram_svg__r-sociaux Instagram_svg__instagram"
    viewBox="0 0 32 32"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path
        fill="currentColor"
        stroke="currentColor"
        strokeWidth={2}
        d="M25.3 13.5v4.9a7.2 7.2 0 0 1-2 5 7.2 7.2 0 0 1-5 1.8l-4.8.1H8.6a7.2 7.2 0 0 1-5-2 7.2 7.2 0 0 1-1.8-5 107 107 0 0 1 0-9.7 7.2 7.2 0 0 1 1.9-5 7.2 7.2 0 0 1 4.9-1.8 107 107 0 0 1 9.8 0c1.8 0 3.6.6 5 1.9a7.2 7.2 0 0 1 1.8 5z"
        className="Instagram_svg__footer_ico_path"
      />
      <path
        fill="#FFF"
        stroke="#FFF"
        d="M20.8 7.5a1.3 1.3 0 1 1-2.6 0 1.3 1.3 0 0 1 2.6 0z"
      />
      <path
        fill="#FFF"
        stroke="#FFF"
        strokeWidth={2}
        d="M13.5 8.8a4.7 4.7 0 0 1 0 9.4 4.7 4.7 0 1 1 0-9.4z"
      />
    </g>
  </svg>
);
export default SvgInstagram;
